// JS
import '../../custom/js/index';

// JS Components
import '../../custom/js/components/Hero/hero';
import '../../custom/js/components/recipe-collection-card-group';

// Base SCSS
import '../../custom/scss/base.scss';

// Components SCSS
import '../../custom/js/components/accordion';
import '../../custom/js/components/modal';
import '../../custom/scss/components/accordion/accordion.scss';
import '../../custom/scss/components/recipes/recipe-collection-card-group.scss';
import '../../custom/scss/components/recipes/recipe-collection-latest-recipes.scss';

import '../../custom/scss/pages/recipe-featured-collection.scss';
